import { FadeIn } from '@dreamstack/feature-components/src/layout/FadeIn'
import { SimpleError } from '@dreamstack/feature-components/src/layout/SimpleError'
import type { FunctionComponent } from 'react'

import { AllBlocksPayload } from '../blocks/AllBlocksPayload'

export const ContentfulBlock: FunctionComponent<
  React.PropsWithChildren<{
    block: any
    customProps?: any
  }>
> = ({ block, customProps }) => {
  const blockType = block?.blockType ?? 'no-block-type'
  const BlockComponent = AllBlocksPayload[blockType]

  if (!BlockComponent) {
    const errorMsg = `Unknown BlockType "${blockType}" ${
      block?.__typename ? `(${block?.__typename})` : ''
    }`
    console.error(errorMsg)
    return <SimpleError msg={errorMsg} json={block} />
  }
  return (
    <FadeIn>
      <BlockComponent block={block} customProps={customProps} />
    </FadeIn>
  )
}
